
import { ProtocolVisibleFields, ProtocolConfiguration as ProtocolConfiguration_1, FormState__setValidationResponse_5219762A, FormState_get_empty, RequestedValue$1 } from "../../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { updateProtocolConfiguration, getCustomerConfiguration } from "../../../Requests/Configuration.js";
import { ofArray, singleton } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_OfPromise_either } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../CommunicationV2.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { string_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Cmd_successToast, Cmd_errorToast } from "../../../Components/Toast.js";
import { onBlobReceived } from "../../../CommunicationV2.js";

export const initialState = new State(new RequestedValue$1(0, []), new RequestedValue$1(0, []), FormState_get_empty());

export function init() {
    return [initialState, Cmd_batch(singleton(getCustomerConfiguration((Item) => (new Msg(6, [Item])), (Item_1) => (new Msg(9, [Item_1])))))];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 2:
            if (state.ProtocolConfiguration.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [state, Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_2;
                    return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response) => {
                        const pr = response.arrayBuffer();
                        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                    }, refreshOn)))(true);
                })), "/api/customer/protocol/image", (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(9, [Item_1])))];
            }
        case 3: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [new State(state.CustomerConfiguration, state.ProtocolConfiguration, FormState__setValidationResponse_5219762A(state.FormState, response_1.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                const matchValue_2 = state.ProtocolConfiguration;
                if (matchValue_2.tag === 0) {
                    return [state, Cmd_none()];
                }
                else {
                    return [state, updateProtocolConfiguration(new ProtocolConfiguration_1(undefined, matchValue_2.fields[0].ProtocolVisibleFields), (Item_2) => (new Msg(8, [Item_2])), (Item_3) => (new Msg(9, [Item_3])))];
                }
            }
        }
        case 1: {
            const file = msg.fields[0];
            if (state.ProtocolConfiguration.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const formData = new FormData();
                formData.append(file.name, file);
                return [state, Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_5;
                    return ((url_5 = addPrefix(tupledArg[0]), (refreshOn_1) => fetchWithDecoder(url_5, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), undefined, (response_2) => {
                        const pr_1 = response_2.arrayBuffer();
                        return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), string_type));
                    }, refreshOn_1)))(true);
                })), ["/api/customer/protocol/image", formData], (Item_4) => (new Msg(4, [Item_4])), (Item_5) => (new Msg(9, [Item_5])))];
            }
        }
        case 4: {
            const response_3 = msg.fields[0];
            if (response_3.tag === 1) {
                return [new State(state.CustomerConfiguration, state.ProtocolConfiguration, FormState__setValidationResponse_5219762A(state.FormState, response_3.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                const matchValue_4 = state.ProtocolConfiguration;
                if (matchValue_4.tag === 0) {
                    return [state, Cmd_none()];
                }
                else {
                    return [state, updateProtocolConfiguration(new ProtocolConfiguration_1(response_3.fields[0], matchValue_4.fields[0].ProtocolVisibleFields), (Item_6) => (new Msg(8, [Item_6])), (Item_7) => (new Msg(9, [Item_7])))];
                }
            }
        }
        case 5: {
            onBlobReceived(msg.fields[0], msg.fields[1]);
            return [state, Cmd_none()];
        }
        case 7: {
            const matchValue_5 = state.ProtocolConfiguration;
            if (matchValue_5.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [state, updateProtocolConfiguration(matchValue_5.fields[0], (Item_8) => (new Msg(8, [Item_8])), (Item_9) => (new Msg(9, [Item_9])))];
            }
        }
        case 6: {
            const response_4 = msg.fields[0];
            return [new State(new RequestedValue$1(1, [response_4]), new RequestedValue$1(1, [response_4.ProtocolConfiguration]), state.FormState), Cmd_none()];
        }
        case 8: {
            const response_5 = msg.fields[0];
            if (response_5.tag === 1) {
                return [new State(state.CustomerConfiguration, state.ProtocolConfiguration, FormState__setValidationResponse_5219762A(state.FormState, response_5.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.CustomerConfiguration, state.ProtocolConfiguration, FormState_get_empty()), Cmd_batch(ofArray([Cmd_successToast("general.saved_successfully"), getCustomerConfiguration((Item_10) => (new Msg(6, [Item_10])), (Item_11) => (new Msg(9, [Item_11])))]))];
            }
        }
        case 9:
            return [state, Cmd_none()];
        default: {
            const matchValue = state.ProtocolConfiguration;
            if (matchValue.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.CustomerConfiguration, new RequestedValue$1(1, [new ProtocolConfiguration_1(matchValue.fields[0].ImageUrl, new ProtocolVisibleFields(msg.fields[0]))]), state.FormState), Cmd_none()];
            }
        }
    }
}

